@let positionDataValue = positionData()!;
@let memberValue = member()!;

<rt-dialog-header
  class="error"
  [heading]="
    'tlc.positions.position_details_dialog.tabs.employees.unassign_members_dialog.header'
      | translate
  "
/>
<rt-dialog-body variant="white">
  <div class="member-container">
    <rt-avatar
      [type]="!!memberValue.avatarThumbUrl ? 'image' : 'initials'"
      [imageSrc]="memberValue.avatarThumbUrl"
      [fullName]="memberFullName()"
      [context]="'admin'"
    />
    <div class="member-details">
      <span class="member-name">{{ memberFullName() }}</span>
      <span class="email">{{ memberValue.email }}</span>
    </div>
  </div>
  <span
    class="info-text"
    [innerHTML]="
      'tlc.positions.position_details_dialog.tabs.employees.unassign_members_dialog.info'
        | translate: { member: memberFullName(), position: positionDataValue.name }
    "
  ></span>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button class="optional" variant="error" (click)="unassign()" [loading]="loading()">
    {{
      'tlc.positions.position_details_dialog.tabs.employees.unassign_members_dialog.confirm'
        | translate
    }}
  </rt-button>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
</rt-dialog-footer>
